<template>
  <div id="app">
    <div v-if="!hideAllNav">
      <div class="sidebar-container">
        <the-sidebar></the-sidebar>
      </div>
      <div class="main-container">
        <div v-if="!hideMobileNav" class="the-navbar">
          <the-navbar></the-navbar>
        </div>
        <router-view></router-view>
      </div>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import TheSidebar from '@/components/TheSidebar.vue';
import TheNavbar from '@/components/TheNavbar.vue';
import EventBus from '@/helpers/event-bus';
import router from './router';

export default {
  name: 'app',
  components: {
    TheSidebar,
    TheNavbar,
  },
  computed: {
    hideAllNav() {
      return ['signup', 'login', 'reset', 'confirmReset', 'privacyPolicy', 'gdpr', 'terms'].includes(this.$route.name)
    },
    hideMobileNav() {
      return ['editor'].includes(this.$route.name)
    }
  },
}
</script>
